/*
  cp-cp — CharmPup acrylic tag PDP controller.

  Presentation only. The colour radios drive the variant, and the name, font
  and charm controls are themselves the line-item-property inputs, so the
  form still adds the right thing to the cart with this file blocked. What
  is lost without it is the live preview, the price swap and the nudge on
  the button.

  The drawn tag appears three times (gallery stage, its thumbnail, step 2)
  and every copy carries the same data-cp-cp hooks. Everything here uses
  qa() + forEach, never a single q(), so the copies cannot disagree.

  All per-colour, per-font and per-charm data is read off the radio's data-*
  attributes, so a block added in the theme editor works with no build step.
*/
(function () {
  'use strict';

  var qa = function (root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  };

  /* The comp's step-down by name length, as a share of the tag width. */
  function sizeFor(len) {
    var scale = len <= 4 ? 1 : len <= 6 ? 0.82 : len <= 8 ? 0.66 : len <= 10 ? 0.55 : 0.46;
    return 22 * scale;
  }

  function init(root) {
    if (root.dataset.cpCpReady === '1') return;
    root.dataset.cpCpReady = '1';

    var colours = qa(root, '[data-cp-cp-colour]');
    var fonts = qa(root, '[data-cp-cp-font]');
    var charms = qa(root, '[data-cp-cp-charm]');
    var inks = qa(root, '[data-cp-cp-ink]');
    var nameInput = root.querySelector('[data-cp-cp-name]');
    var variantField = root.querySelector('[data-cp-cp-variant]');
    var cta = root.querySelector('[data-cp-cp-cta]');
    var form = cta ? cta.form : null;
    var sticky = root.querySelector('[data-cp-cp-sticky]');
    var stickyBtn = root.querySelector('[data-cp-cp-stickybtn]');
    var stickyImg = root.querySelector('[data-cp-cp-stickyimg]');
    var fallback = root.dataset.cpCpNameFallback || 'Milo';
    /* The editor's "Name size" slider, as a multiplier on the length step-down. */
    var nameScale = (parseFloat(root.dataset.cpCpNameScale) || 125) / 100;

    function selected(list) {
      for (var i = 0; i < list.length; i++) if (list[i].checked) return list[i];
      return null;
    }

    /* ------------------------------------------------------------ gallery */

    var panes = qa(root, '[data-cp-cp-pane]');
    var thumbs = qa(root, '[data-cp-cp-thumb]');
    var liveShownOnce = false;

    function show(key) {
      if (!root.querySelector('[data-cp-cp-pane="' + key + '"]')) return;
      panes.forEach(function (p) {
        var on = p.dataset.cpCpPane === key;
        p.hidden = !on;
        qa(p, 'video').forEach(function (v) {
          if (on) {
            v.muted = true;
            var r = v.play();
            if (r && r.catch) r.catch(function () {});
          } else {
            v.pause();
          }
        });
      });
      thumbs.forEach(function (t) {
        var on = t.dataset.cpCpThumb === key;
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) revealThumb(t);
      });
      if (key === 'live') fit();
    }

    /* Scroll the rail — never the page — so the active thumbnail is in view.
       scrollIntoView() would also scroll the window and yank the shopper
       away from the picker they just used. */
    function revealThumb(t) {
      var rail = t.parentNode;
      if (!rail || rail.scrollWidth <= rail.clientWidth) return;
      var left = t.offsetLeft - rail.offsetLeft;
      var right = left + t.offsetWidth;
      if (left < rail.scrollLeft || right > rail.scrollLeft + rail.clientWidth) {
        rail.scrollTo({ left: Math.max(0, left - 8), behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.dataset.cpCpThumb); });
    });

    /* A colour change moves the stage: to the live tag once a name is typed
       (it IS that colour now), otherwise to the colour's own variant photo. */
    function followColour() {
      var c = selected(colours);
      if (!c) return;
      if (hasName()) { show('live'); return; }
      if (c.dataset.media) show(c.dataset.media);
    }

    function hasName() { return !!(nameInput && nameInput.value.trim()); }

    /*
      The live preview is not gallery media until the shopper has something
      of their own on it: the LIVE thumbnail stays hidden on load, appears on
      the first typed character, and goes again if the name is cleared —
      handing the stage back to the colour's photo (or the first photo).
      With no product media at all it is the only pane, so it never hides.
    */
    var liveThumb = root.querySelector('[data-cp-cp-thumb="live"]');
    var mediaPanes = panes.filter(function (p) { return p.dataset.cpCpPane !== 'live'; });

    function syncLiveThumb() {
      if (!liveThumb || mediaPanes.length === 0) return;
      var typed = hasName();
      liveThumb.hidden = !typed;
      if (!typed && currentKey() === 'live') {
        var c = selected(colours);
        var key = c && c.dataset.media ? c.dataset.media : mediaPanes[0].dataset.cpCpPane;
        show(key);
      }
    }

    function currentKey() {
      for (var i = 0; i < panes.length; i++) if (!panes[i].hidden) return panes[i].dataset.cpCpPane;
      return null;
    }

    /* ------------------------------------------------------------ preview */

    /*
      The length step-down guesses a size; it cannot know that Pacifico's
      swashes run wider than Lilita. So after the guess, measure one visible
      copy and shrink until the name sits inside the tag. Sizes are cqw, so
      the ratio measured on one copy holds on every copy and at every width.
    */
    function fit() {
      var names = qa(root, '[data-cp-cp-engname]');
      var probe = null;
      for (var i = 0; i < names.length; i++) {
        if (names[i].offsetWidth > 0 && names[i].closest('.cp-cp-tag--thumb') === null) { probe = names[i]; break; }
      }
      if (!probe) return;
      var body = probe.parentNode;
      var avail = body.clientWidth * 0.86;
      var size = parseFloat(probe.style.fontSize) || 0;
      if (!size || !avail) return;
      if (probe.scrollWidth > avail) {
        var next = (size * avail / probe.scrollWidth).toFixed(2) + 'cqw';
        names.forEach(function (el) { el.style.fontSize = next; });
      }
    }

    function render() {
      var c = selected(colours) || colours[0];
      var f = selected(fonts) || fonts[0];
      var m = selected(charms);
      var typed = nameInput ? nameInput.value.trim() : '';
      var text = typed || fallback;

      /*
        Letter colour: the "Matched" tile follows the tag colour's own
        pairing; any other tile is its fixed colour. The Matched radio's value
        is rewritten to the real colour name (looked up by hex among the ink
        tiles) so the order never records just "Matched".
      */
      var pairedInk = c ? (c.dataset.ink || '#ffffff') : '#ffffff';
      var k = selected(inks);
      var ink = k && !k.dataset.auto ? (k.dataset.hex || pairedInk) : pairedInk;
      var pairedName = pairedInk;
      inks.forEach(function (r) {
        if (!r.dataset.auto && (r.dataset.hex || '').toLowerCase() === pairedInk.toLowerCase()) pairedName = r.dataset.label;
      });
      inks.forEach(function (r) { if (r.dataset.auto) r.value = pairedName; });
      qa(root, '[data-cp-cp-inkauto]').forEach(function (dot) {
        dot.style.setProperty('--ink', pairedInk);
        if (c) dot.style.setProperty('--tag', c.dataset.tag || '#1a56c4');
      });
      qa(root, '[data-cp-cp-inkname]').forEach(function (el) {
        if (!k) return;
        el.textContent = k.dataset.auto ? (k.dataset.label + ' · ' + pairedName) : k.dataset.label;
      });

      var scale = f ? parseFloat(f.dataset.scale || '1') : 1;
      if (!isFinite(scale) || scale <= 0) scale = 1;
      var size = (sizeFor(text.length) * scale * nameScale).toFixed(2) + 'cqw';

      qa(root, '[data-cp-cp-engname]').forEach(function (el) {
        el.textContent = text;
        el.style.opacity = typed ? '1' : '0.35';
        el.style.fontSize = size;
        el.style.color = ink;
        if (f) {
          el.style.fontFamily = f.dataset.family || '';
          el.style.fontWeight = f.dataset.weight || '600';
        }
      });

      qa(root, '[data-cp-cp-fill]').forEach(function (el) {
        if (c) el.style.background = c.dataset.tag || '#1a56c4';
      });

      var src = m ? (m.dataset.src || '') : '';
      qa(root, '[data-cp-cp-charmimg]').forEach(function (img) {
        if (src) {
          if (img.getAttribute('src') !== src) img.setAttribute('src', src);
          /* Hang the charm by its own hole — see .cp-cp-tag__charm. */
          img.style.setProperty('--hx', parseFloat(m.dataset.hx) || 50);
          img.style.setProperty('--hy', parseFloat(m.dataset.hy) || 25);
          img.style.setProperty('--rot', (parseFloat(m.dataset.rot) || 0) + 'deg');
          img.style.setProperty('--cs', parseFloat(m.dataset.cs) || 55);
          img.hidden = false;
        } else {
          img.hidden = true;
        }
      });
      qa(root, '[data-cp-cp-charmring]').forEach(function (ring) { ring.hidden = !src; });

      fit();

      /* -------------------------------------------------------- labels */

      qa(root, '[data-cp-cp-colourname]').forEach(function (el) {
        el.textContent = c ? (c.dataset.label || '') : '';
      });
      if (m) {
        qa(root, '[data-cp-cp-charmname]').forEach(function (el) {
          el.textContent = m.dataset.label || '';
        });
      }

      /* --------------------------------------------------------- money */

      if (c) {
        if (variantField && c.dataset.variant) variantField.value = c.dataset.variant;
        qa(root, '[data-cp-cp-price]').forEach(function (el) {
          el.textContent = c.dataset.price || el.textContent;
        });
        qa(root, '[data-cp-cp-compare]').forEach(function (el) {
          el.textContent = c.dataset.compare || '';
          el.hidden = !c.dataset.compare;
        });
        qa(root, '[data-cp-cp-save]').forEach(function (el) {
          var v = el.dataset.cpCpSave === 'short' ? c.dataset.saveShort : c.dataset.save;
          el.textContent = v || '';
          el.hidden = !v;
        });
      }

      /* ----------------------------------------------------------- cta */

      var available = c ? c.dataset.available === 'true' : false;
      var ready = !!typed && available;

      if (cta) {
        var label;
        if (!available) label = cta.dataset.soldout || 'Sold out';
        else if (!typed) label = cta.dataset.blocked || 'Add their name to continue';
        else label = (cta.dataset.ready || 'Add to cart').replace('{amount}', (c && c.dataset.price) || '');
        // Write the label span only — cta.textContent would wipe the icon.
        var labelEl = cta.querySelector('[data-cp-cp-ctalabel]');
        if (labelEl) labelEl.textContent = label;
        cta.classList.toggle('cp-cp-cta--soldout', !available);
        cta.disabled = !available;
        cta.setAttribute('aria-disabled', ready ? 'false' : 'true');
      }

      if (stickyBtn) {
        stickyBtn.dataset.state = !available ? 'soldout' : typed ? 'ready' : 'blocked';
        stickyBtn.textContent = !available
          ? (cta && cta.dataset.soldout) || 'Sold out'
          : typed
            ? stickyBtn.dataset.ready || 'Add to cart'
            : stickyBtn.dataset.blocked || 'Personalise';
      }
      if (stickyImg && c && c.dataset.thumb && stickyImg.getAttribute('src') !== c.dataset.thumb) {
        stickyImg.setAttribute('src', c.dataset.thumb);
      }

      qa(root, '[data-cp-cp-warn]').forEach(function (el) {
        el.classList.toggle('cp-cp-warn--off', !!typed);
      });

      if (nameInput) {
        qa(root, '[data-cp-cp-count]').forEach(function (el) {
          el.textContent = nameInput.value.length + '/' + (nameInput.maxLength > 0 ? nameInput.maxLength : '');
        });
      }
    }

    /* -------------------------------------------------------------- wire */

    colours.forEach(function (i) {
      i.addEventListener('change', function () { render(); followColour(); });
    });
    fonts.forEach(function (i) {
      i.addEventListener('change', function () { render(); if (hasName()) show('live'); });
    });
    charms.forEach(function (i) {
      i.addEventListener('change', function () { render(); if (hasName()) show('live'); });
    });
    inks.forEach(function (i) {
      i.addEventListener('change', function () { render(); if (hasName()) show('live'); });
    });

    if (nameInput) {
      nameInput.addEventListener('input', function () {
        var pattern = nameInput.dataset.strip;
        if (pattern) {
          try {
            /* Accented letters always pass, the same set the collars take. */
            var cleaned = nameInput.value.normalize('NFC').replace(new RegExp(pattern.replace('[^', '[^À-ÖØ-öø-ſ'), 'g'), '');
            if (cleaned !== nameInput.value) nameInput.value = cleaned;
          } catch (e) { /* a bad pattern from the editor must not break typing */ }
        }
        render();
        syncLiveThumb();
        /* The first character hands the stage to the live tag, once — the
           latch stops it yanking the stage back on every keystroke. */
        if (hasName() && !liveShownOnce) { liveShownOnce = true; show('live'); }
        if (!hasName()) liveShownOnce = false;
      });
    }

    /* The button stays clickable without a name so it can say why: bring
       the name field into view and nudge it, instead of a dead control. */
    if (cta && form) {
      /* On the button, not the form: Horizon's submit handler runs first, in the
         capture phase, and would post the form whatever a submit listener says. */
      cta.addEventListener('click', function (e) {
        if (nameInput && !nameInput.value.trim()) {
          e.preventDefault();
          nameInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          nameInput.classList.remove('cp-cp-input--nudge');
          void nameInput.offsetWidth;
          nameInput.classList.add('cp-cp-input--nudge');
          setTimeout(function () { nameInput.focus({ preventScroll: true }); }, 350);
        }
      });
      /* The native `required` bubble would fire before submit; the nudge
         above replaces it while this script runs. */
      form.noValidate = true;
    }

    /* ------------------------------------------------ swipe the stage */

    /* On a phone the stage is the natural thing to swipe, and the rail below
       it scrolls sideways on its own — so a horizontal swipe on the stage
       steps to the neighbouring visible thumbnail, exactly as a tap on it
       would. Vertical drags are left to the page. Same as TrailTag. */
    var stage = root.querySelector('.cp-cp-stage');
    if (stage) {
      var sx = 0;
      var sy = 0;
      var tracking = false;
      stage.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) return;
        /* A drag that starts on the video controls belongs to the scrubber. */
        if (event.target.closest && event.target.closest('video')) return;
        tracking = true;
        sx = event.touches[0].clientX;
        sy = event.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (!tracking) return;
        tracking = false;
        var t = event.changedTouches[0];
        var dx = t.clientX - sx;
        var dy = t.clientY - sy;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
        var visible = thumbs.filter(function (b) { return !b.hidden; });
        var at = -1;
        visible.forEach(function (b, i) { if (b.getAttribute('aria-pressed') === 'true') at = i; });
        var next = visible[at + (dx < 0 ? 1 : -1)];
        if (next) show(next.dataset.cpCpThumb);
      }, { passive: true });
    }

    /* -------------------------------------------- mobile sticky bar */

    /* Shown only once the shopper has scrolled past the form — never while
       any of it is on screen, so it cannot sit over a field they are typing
       into, and not above it either, where the buybox is still coming up. */
    if (sticky && form && 'IntersectionObserver' in window) {
      var formVisible = true;
      var setSticky = function () {
        var past = form.getBoundingClientRect().bottom < 0;
        var on = !formVisible && past;
        sticky.classList.toggle('is-shown', on);
        document.documentElement.classList.toggle('cp-cp-sticky-on', on);
      };
      new IntersectionObserver(function (entries) {
        formVisible = entries[0].isIntersecting;
        setSticky();
      }).observe(form);
      window.addEventListener('scroll', function () {
        if (!formVisible) setSticky();
      }, { passive: true });

      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var c = selected(colours);
          if (c && c.dataset.available !== 'true') return;
          if (hasName() && cta) {
            /* The real submit button, so the form's own checks and the
               theme's cart handling run exactly as for a direct tap. */
            cta.click();
            return;
          }
          if (nameInput) {
            nameInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
            /* preventScroll so focusing does not fight the smooth scroll. */
            nameInput.focus({ preventScroll: true });
          }
        });
      }
    }

    /* Web fonts land after first paint; measure again once they do. */
    if (document.fonts) {
      if (document.fonts.ready) document.fonts.ready.then(render);
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', render);
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(render, 120);
    });

    render();
    syncLiveThumb();
  }

  function boot() { qa(document, '[data-cp-cp-root]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* The theme editor re-renders a section in place; re-init the new copy. */
  document.addEventListener('shopify:section:load', function (e) {
    qa(e.target, '[data-cp-cp-root]').forEach(init);
  });

  /*
    Autoplay band videos only while they are on screen. A bare `autoplay`
    attribute makes the browser fetch the whole clip (6.5 MB for the demo) on
    page load, even for a shopper who never scrolls that far on a phone.
  */
  function bootVideos(scope) {
    var vids = qa(scope, 'video[data-cp-cp-autoplay]');
    if (!vids.length) return;
    var play = function (v) {
      v.muted = true;
      var r = v.play();
      if (r && r.catch) r.catch(function () {});
    };
    if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) play(en.target);
        else en.target.pause();
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) {
      if (v.dataset.cpCpWatched) return;
      v.dataset.cpCpWatched = '1';
      io.observe(v);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bootVideos(document); });
  else bootVideos(document);
  document.addEventListener('shopify:section:load', function (e) { bootVideos(e.target); });

  /* Any "Personalise my tag" link pointing at the buybox scrolls smoothly. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href="#cp-cp-buy"]') : null;
    if (!a) return;
    var target = document.getElementById('cp-cp-buy');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
